import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@app/services/auth/auth.service';
import featureData from '@app/assets/page_feature.json';
import { MatDialog } from '@angular/material/dialog';
import { ViewToolComponent } from '@app/modules/tools/components/view-tool/view-tool.component';
import { ToolsService } from '@app/services/tools.service';
import { MatTableDataSource } from '@angular/material/table';
import { TourGuideService } from '@app/services/tour-guide.service';
import tourData from '@app/assets/api-dummy-data.json'
import { TourGuideContent } from '@app/util/tour-guide-content.util'
import { CommonFunctionalitiesService } from '@app/services/common-functionalities.service';

@Component({
  selector: 'app-tool',
  templateUrl: './tool.component.html',
  styleUrls: ['./tool.component.scss']
})
export class ToolComponent implements OnInit {

  /****************** Variable declaration ******************/
  dataSource: any = new MatTableDataSource<any>([]);
  features: any = {};
  showModal = false;
  selectedRowData: any;
  addtools: string;
  tourGuideIds = TourGuideContent;

  /****************** View child ******************/
  @ViewChild(ViewToolComponent) viewToolComponent: ViewToolComponent;

  /**
   * constructor
   * @param authService 
   * @param dialog 
   * @param toolsService 
   * @param tourGuideService 
   */
  constructor(public readonly authService: AuthService,
    public dialog: MatDialog,
    private toolsService: ToolsService,
    public tourGuideService: TourGuideService,
    public commonService:CommonFunctionalitiesService) { }

  /**ngOnInit */
  ngOnInit() {
    if (this.tourGuideService.isStartTour) {
      this.dataSource = tourData.admin.tools.toolsData;
      return;
    }
    this.getToolDet();
    this.parseFeatures();
    this.checkPermissions();
  }

  /**
   * Parse the features from featureData and assign a boolean value to each feature
   */
  parseFeatures() {
    const config = JSON.parse(JSON.stringify(featureData)); // Parse the JSON file
    for (let i = 0; i < config.length; i++) {
      for (let j = 0; j < config[i].feature.length; j++) {
        const feature = config[i].feature[j];
        this.features[`${feature}`] = false; // Assign a boolean value to each feature
      }
    }
  }

  /**
   * checks the permission for the features to be executed
   */
  checkPermissions() {
    for (const obj in this.features) {
      if (this.authService.hasFeaturePermission(obj)) {
        this.features[obj] = true;
      }
    }
  }

  /**
   *on click of add tool button the modal will be added
   */
  openToolModal(rowData: any = null, edit: string) {
    this.selectedRowData = null;
    this.addtools = edit
    if (edit == 'edit') { this.selectedRowData = rowData; }
    this.showModal = true;
  }

  /**
   * on click of cancel button the modal will be closed
   */
  onCloseModal() {
    this.showModal = false;
    this.selectedRowData = null
  }

  /**refresh view tool */
  refreshViewTool(data: any) {
    data['version'] = data.toolVer
    this.dataSource = new MatTableDataSource<any>([data, ...this.dataSource.data]);
    this.selectedRowData = null;
  }

  /****************************Api calls *****************************/

  /**get tool details */
  getToolDet() {
    if (this.tourGuideService.isStartTour) {
      this.dataSource = tourData.admin.tools.toolsData;
      return;
    }
    this.toolsService.getToolDet().subscribe((response: any) => {
      this.dataSource = new MatTableDataSource<any>(response?.data.dbResp);
    });
  }
}
